import IconLoading from '../icons/loading';
import LoadingLogo from './logo';
import { Container } from './styles';

export interface LoadingIndicatorProps {
  className?: string;
  padded?: boolean;
  scale?: number;
  withLogo?: boolean;
}

export const LOGO_DEFAULT_SIZE = 150;
export const SPINNER_DEFAULT_SCALE = 1;

export const LoadingIndicator = ({ className, withLogo, padded, scale }: LoadingIndicatorProps) => {
  if (withLogo)
    return (
      <Container padded={padded}>
        <LoadingLogo size={scale || LOGO_DEFAULT_SIZE} />
      </Container>
    );

  return (
    <Container padded={padded}>
      <IconLoading className={className} scale={scale || SPINNER_DEFAULT_SCALE} />
    </Container>
  );
};

export default LoadingIndicator;
